import _ from 'lodash'
import { AxiosResponse, AxiosError } from 'axios'
import KeyValuePair from '@/modules/core/support/KeyValuePair';

/**
 * Error lanzado por los métodos de la api
 */
export class ApiError extends Error {
    public type: ErrorType
    public data: KeyValuePair = {}

    /**
     * Crea un error de la api en base a un error lanzado por Axios
     *
     * @param error
     */
    public static fromResponse (error: AxiosError) {
        const err = new this()

        err.type = this.determineErrorType(error)
        err.data = _.get(error, 'response.data', {})
        err.message = err.data.reason || err.data.message || error.message || ''

        return err
    }

    /**
     * Determina el tipo de error en función de la información de la respuesta Http
     *
     * @param error
     */
    private static determineErrorType (error: AxiosError): ErrorType {
        const response = error.response
        if (!response) {
            return ErrorType.Unknown
        }

        switch (response.status) {
            case 404:
                return ErrorType.NotFound
            case 403:
                return ErrorType.Forbidden
            default:
                return ErrorType.Unknown
        }
    }
}

/**
 * Tipos de errores que la API puede lanzar cuando un proceso no se puede completar
 * sobre un recurso.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export enum ErrorType {
    /**
     * Error desconocido
     *
     * Tipo de error definido cuando no se identificar el error que la API ha enviado
     */
    Unknown = 'UNKNOWN',

    /**
     * Recurso no encontrado
     *
     * Definido cuando el cliente intenta leer, actualizar o eliminar un recurso que no
     * existe en la API.
     */
    NotFound = 'NOT_FOUND',

    /**
     * Sin permiso
     *
     * Definido cuando el usuario autenticado intenta acceder a un recurso o ejecutar
     * un proceso al cual no tiene permisos de acceso
     */
    Forbidden = 'FORBIDDEN',
}
